import { render } from "./generalMemberType.vue?vue&type=template&id=268af4ee"
const script = {}

import "./generalMemberType.vue?vue&type=style&index=0&id=268af4ee&lang=scss&scope=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__